import React from 'react';
import PropTypes from 'prop-types';
import './StudioGrid.css';
import ScrollAnimation from 'react-animate-on-scroll';
import LazyBg from '../../../UI/LazyImage/LazyBg';

const renderWordsWithBreaks = (text = '') => {
  const words = text
    .split(' ')          
    .filter(Boolean);    

  return words.map((word, index) => (
    <React.Fragment key={index}>
      {word}
      {index < words.length - 1 && <br />}
    </React.Fragment>
  ));
};

const StudioGrid = ({ studios, quixote }) => {
    return (
        <div className="studio-grid">
            {/* SUNSET INFO */}
            <div className="sunset-group">
                <div className="section grid-view">
                    <div className="studio-container sunset-container">
                        <div className="container">
                            <div className="columns is-multiline is-mobile">
                                <div className="column is-12-mobile is-12-tablet is-12-desktop is-6-widescreen">
                                    <div className="studio-logo-container">
                                        <ScrollAnimation duration={1.3} animateOnce={true} animateIn={'fadeInLeft'} initiallyVisible={false}>
                                            <div className="sunset-logo animated fadeInLeft"></div>
                                        </ScrollAnimation>
                                    </div>
                                </div>
                                <div className="column is-12-mobile is-12-tablet is-12-desktop is-6-widescreen">
                                    <div className="studio-copy">
                                        <ScrollAnimation duration={1.4} delay={200} animateOnce={true} animateIn={'fadeInRight'} initiallyVisible={false}>
                                            Through acquisitions, redevelopment, and ground-up development, Hudson Pacific has built Sunset Studios into a leading independent operator of purpose-built studio facilities in Los Angeles and New York. Our campuses are designed to meet the scale, quality, and location requirements of today’s productions—and are well positioned for long-term demand. 
                                        </ScrollAnimation>
                                        <br />
                                        <br />
                                        <br />
                                        <ScrollAnimation duration={1.5} delay={300} animateOnce={true} animateIn={'fadeInRight'} initiallyVisible={false}>
                                            <a
                                                href="https://www.sunsetstudios.com/"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="button visit-website animated fadeInRight"
                                            >
                                                <span>VISIT WEBSITE</span>
                                            </a>
                                        </ScrollAnimation>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* PROPERTY GRID */}
                    <div className="grid-content-container">
                        <div className="container">
                            <div className="columns is-multiline">
                                {Object.values(studios).map((studio, index) => {
                                    const mastheadImage = `${process.env.RAZZLE_ASSET_URL}${studio.mastheadImage}`;
                                    // THIS FIELD ID IS RETAINED BUT THE LABEL IS NOW "TYPE"
                                    const existing_facilities_label = studio.existing_facilities_label.trim();
                                    const existing_facilities_stage = studio.existing_facilities_stage.trim();
                                    const existing_facilities_sq_ft = studio.existing_facilities_sq_ft.trim();
                                    const submarket = studio.submarket.trim();

                                    return (
                                        <div
                                            key={index}
                                            className={`grid-item
                                        column
                                        is-12-mobile
                                        is-half-tablet
                                        is-half-desktop
                                        is-half-widescreen
                                        is-half-fullhd`}
                                        >
                                            <div className="property-wrapper">
                                                <div className="grid-image">
                                                    <div className="image grid-image-container">
                                                        <LazyBg src={mastheadImage} className="lazy-image" />
                                                        <div className="location-container">
                                                            <div className="location">{studio.name}</div>
                                                            <div className="location-city">{studio.street_address}</div>
                                                        </div>
                                                    </div>
                                                </div>
                                                {/* <div className="info-body">{studio.body}</div> */}
                                                <div className="info-wrapper">
                                                    <div className="columns is-multiline is-gapless">
                                                        <div className="column is-4-mobile is-5-tablet">
                                                            {submarket && (
                                                                <div className="info-text-wrapper">
                                                                    <div className="info-text info-title-submarket">
                                                                        <span className="info-bold-2">SUBMARKET</span>
                                                                    </div>
                                                                </div>
                                                            )}
                                                        </div>
                                                        <div className="column is-7-mobile is-7-tablet">
                                                            {submarket && (
                                                                <div className="info-text-wrapper">
                                                                    <div className="info-text info-title-submarket studio-info-semibold">{submarket}</div>
                                                                </div>
                                                            )}
                                                        </div>
                                                        <div className="column is-4-mobile is-5-tablet">
                                                            {(existing_facilities_stage || existing_facilities_sq_ft) && (
                                                                <div className="info-text-wrapper">
                                                                    <div className="info-text info-title">
                                                                        <span className="info-bold-2">TYPE</span>
                                                                    </div>
                                                                </div>
                                                            )}
                                                        </div>
                                                        <div className="column is-7-mobile is-7-tablet">
                                                            {(existing_facilities_stage || existing_facilities_sq_ft) && (
                                                                <div className="info-text-wrapper">
                                                                    <div className="info-text info-title studio-info-semibold">{renderWordsWithBreaks(existing_facilities_label)}</div>
                                                                </div>
                                                            )}
                                                        </div>
                                                        <div className="column is-4-mobile is-5-tablet">
                                                            {(existing_facilities_stage || existing_facilities_sq_ft) && (
                                                                <div>
                                                                    <div className="info-text-wrapper">
                                                                        <div className="info-text info-title info-bold-2">STAGES</div>
                                                                    </div>
                                                                </div>
                                                            )}
                                                        </div>
                                                        <div className="column is-7-mobile is-7-tablet">
                                                            {(existing_facilities_stage || existing_facilities_sq_ft) && (
                                                                <div>
                                                                    <div className="info-text-wrapper">
                                                                        <div className="info-text info-stages studio-info-semibold">{existing_facilities_stage}</div>
                                                                    </div>
                                                                </div>
                                                            )}
                                                        </div>
                                                        <div className="column is-7-mobile is-5-tablet">
                                                            <div>
                                                                {(existing_facilities_stage || existing_facilities_sq_ft) && (
                                                                    <div>
                                                                        <div className="info-text-wrapper">
                                                                            <div className="info-text info-title info-bold-2">TOTAL SQ FT</div>
                                                                        </div>
                                                                    </div>
                                                                )}
                                                            </div>
                                                        </div>
                                                        <div className="column is-7-mobile is-7-tablet">
                                                            <div>
                                                                {(existing_facilities_stage || existing_facilities_sq_ft) && (
                                                                    <div>
                                                                        <div className="info-text-wrapper">
                                                                            <div className="info-text info-sq studio-info-semibold">{existing_facilities_sq_ft}</div>
                                                                        </div>
                                                                    </div>
                                                                )}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <hr className="grid-hr" />
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="studio-separator"></div>
            <div className="quixote-group">
                <div className="section grid-view">
                    {/* QUIXOTE INFO* */}
                    <div className="studio-container quixote-container">
                        <div className="container">
                            <div className="columns is-multiline is-mobile">
                                <div className="column is-12-mobile is-12-tablet is-12-desktop is-6-widescreen">
                                    <div className="studio-logo-container">
                                        <ScrollAnimation duration={1.3} animateOnce={true} animateIn={'fadeInLeft'} initiallyVisible={false}>
                                            <div className="quixote-logo"></div>
                                        </ScrollAnimation>
                                    </div>
                                </div>
                                <div className="column is-12-mobile is-12-tablet is-12-desktop is-6-widescreen">
                                    <div className="studio-copy">
                                        <ScrollAnimation duration={1.4} delay={200} animateOnce={true} animateIn={'fadeInRight'} initiallyVisible={false}>
                                           Hudson Pacific owns Quixote, a leading provider of production equipment, supplies, and transportation services. Quixote operates facilities in Los Angeles and New York that offer essential on‑ and off‑lot production services.
                                        </ScrollAnimation>
                                        <br />
                                        <br />
                                        <ScrollAnimation duration={1.5} delay={300} animateOnce={true} animateIn={'fadeInRight'} initiallyVisible={false}>
                                            <a href="https://quixote.com/" target="_blank" rel="noopener noreferrer" className="button visit-website">
                                                <span>VISIT WEBSITE</span>
                                            </a>
                                        </ScrollAnimation>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* QUIXOTE GRID */}
                    <div className="quixote-grid">
                        <div className="container">
                            <div className="columns is-multiline">
                                {Object.values(quixote).map((studio, index) => {
                                    const mastheadQuixoteImage = `${process.env.RAZZLE_ASSET_URL}${studio.mastheadImage}`;
                                    const quixoteName = studio.name;

                                    return (
                                        <div
                                            key={index}
                                            className={`grid-item
                            column
                            is-12-mobile
                            is-half-tablet
                            is-one-third-desktop
                            is-one-third-widescreen
                            is-one-third-fullhd`}
                                        >
                                            <div className="property-wrapper">
                                                <div className="grid-image">
                                                    <div className="image grid-image-container">
                                                        <LazyBg src={mastheadQuixoteImage} className="lazy-image" />
                                                        <div className="location-container">
                                                            <div className="location">{quixoteName}</div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <hr className="grid-hr" />
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

StudioGrid.propTypes = {
    studios: PropTypes.array,
    quixote: PropTypes.array,
};

export default StudioGrid;
